// extracted by mini-css-extract-plugin
export default {"row":"EditLogo_row__TPQtB","buttonTitle":"EditLogo_buttonTitle__Fm8vE","errorMessage":"EditLogo_errorMessage__rVCic"};